<ion-content *ngIf="(colorsSelected$ | async) as colorsSelected">
  <div class="content">
    <div class="color-in-select" [class.using]="isSelected(color)" *ngFor="let color of getAllColors()" [ngStyle]="{'background-color':  color }" (click)="setColor(color, isSelected(color))">
    </div>
  </div>
</ion-content>
